const dialog = require('../../../../../components/dialog/dialog')
const dtHandler = require('../../../../../components/dt/dt-handler')
const formats = require('../../../../../js-handler/math')

export function start(detail){

      dialogBody[detail.id].start(detail)

      detail.html = dialogBody[detail.id]
      dialog.start(detail)
}

const dialogBody = {

      confirmUpdate: {
            title:    '',
            des:      '',
            bodyHtml: '',

            primary: {
                  text:       'Update',
                  class:      'button primary',
                  dataDetail: '',
            },

            secondary: {
                  text:       'Cancel',
                  class:      'button secondary button-flat',
                  dataDetail: '',
            },

            tertiary: {
                  text:       '',
                  class:      '',
                  dataDetail: '',
            },

            start: function(detail){

                  this.title = 'Update Inventory?'
                  this.des   = 'Are you sure you want to report a loss of:'
                  this.bodyHtml = inventoryUpdateTable(detail.lines)

                  this.primary.dataDetail = `data-detail='{
                        "click": [
                              {"dest":"ripple"},
                              {"dest":"dialog", "act":"hide"},
                              {"dest":"inventoryUpdate", "elem":"fullcont", "id":"inventoryUpdate-fullcont", "act":"confirmUpdate"}
                        ]}'`

                  this.secondary.dataDetail = `data-detail='{
                        "click": [
                              {"dest":"ripple"},
                              {"dest":"dialog", "act":"hide"}
                        ]}'`
            },
      },

      quantityExceeded: {
            title:    '',
            des:      '',
            bodyHtml: '',

            primary: {
                  text:       'Close',
                  class:      'button primary',
                  dataDetail: '',
            },

            secondary: {
                  text:       '',
                  class:      '',
                  dataDetail: '',
            },

            tertiary: {
                  text:       '',
                  class:      '',
                  dataDetail: '',
            },

            start: function(detail){

                  this.title    = 'Invalid Inventory Quantity'
                  this.des      = 'You cannot enter a quantity greater than the available quantity.'
                  this.bodyHtml = quantityExceededTable(detail.lines)

                  this.primary.dataDetail = `data-detail='{
                        "click": [
                              {"dest":"ripple"},
                              {"dest":"dialog", "act":"hide"}
                        ]}'`
            },
      },

      discardChanges: {
            title:    '',
            des:      '',
            bodyHtml: '',

            primary: {
                  text:       'Continue editing',
                  class:      'button primary',
                  dataDetail: '',
            },

            secondary: {
                  text:       'Discard',
                  class:      'button secondary button-flat',
                  dataDetail: '',
            },

            tertiary: {
                  text:       '',
                  class:      '',
                  dataDetail: '',
            },

            start: function(detail){

                  this.title = 'Discard Inventory Update changes?'
                  this.des   = 'The values entered in Qty and Selling Price will be lost.'

                  this.primary.dataDetail = `data-detail='{
                        "click": [
                              {"dest":"ripple"},
                              {"dest":"dialog", "act":"hide"}
                        ]}'`

                  this.secondary.dataDetail = `data-detail='{
                        "click": [
                              {"dest":"ripple"},
                              {"dest":"dialog", "act":"hide"},
                              {"dest":"inventoryUpdate", "elem":"fullcont", "id":"inventoryUpdate-fullcont", "act":"discard"}
                        ]}'`
            },
      },
}

function inventoryUpdateTable(lines){

      const data = lines.map((line)=>{
            const lossQty            = Number(line.available_qty) - Number(line.qty)
            const sellingPrice       = Number(line.selling_price)
            const sellingPriceChanged = sellingPrice !== Number(line.original_selling_price)

            return {
                  purchase_code: escapeHTML(line.purchase_code),
                  item:          escapeHTML(line.item),
                  unit:          escapeHTML(line.unit),
                  loss_qty:      lossQty > 0 ? lossQty : '-',
                  selling_price: sellingPriceChanged ? formats.cashFormat(sellingPrice, true) : '-',
            }
      })

      const columns = [
            {key: 'purchase_code', label: 'PO'},
            {key: 'item', label: 'Item'},
            {key: 'unit', label: 'Unit'},
            {key: 'loss_qty', label: 'Loss Qty'},
            {key: 'selling_price', label: 'Selling Price'},
      ]

      const container = document.createElement('div')
      container.innerHTML = dtHandler.dtSimpleFc(data, columns)

      const rows = container.querySelectorAll('tbody tr')

      rows.forEach((row, index)=>{
            const values = row.querySelectorAll('.value-text')
            const line   = lines[index]

            if(data[index].loss_qty !== '-'){
                  highlightValue(values[3])
            }

            if(Number(line.selling_price) !== Number(line.original_selling_price)){
                  highlightValue(values[4])
            }
      })

      return container.innerHTML
}

function highlightValue(value){

      value.classList.add('font-red')
      value.style.fontWeight = '700'
}

function quantityExceededTable(lines){

      const data = lines.map((line)=>{
            return {
                  purchase_code: escapeHTML(line.purchase_code),
                  item:          escapeHTML(line.item),
                  unit:          escapeHTML(line.unit),
                  available_qty: line.available_qty,
                  entered_qty:   line.entered_qty,
            }
      })

      const columns = [
            {key: 'purchase_code', label: 'PO'},
            {key: 'item', label: 'Item'},
            {key: 'unit', label: 'Unit'},
            {key: 'available_qty', label: 'Available Qty', format: 'int'},
            {key: 'entered_qty', label: 'Entered Qty', format: 'int'},
      ]

      const container = document.createElement('div')
      container.innerHTML = dtHandler.dtSimpleFc(data, columns)

      container.querySelectorAll('tbody tr').forEach((row)=>{
            highlightValue(row.querySelectorAll('.value-text')[4])
      })

      return container.innerHTML
}

function escapeHTML(value){

      return `${value ?? ''}`
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;')
}
